export default "__VITE_ASSET__6JcaNTEh__"